export default __webpack_public_path__ + "static/media/all.52a4056a.svg";